// @flow
import React from 'react';
import {compose} from 'redux';
import {injectIntl, type IntlShape} from 'react-intl';

import './ResultsCount.less';
import resultsCountText from '../../utils/resultsCountText';

export type Shape = {
    fromRecord: number,
    toRecord: number,
    resultCount: number
};

export type Props = {
    resultsCount: Shape,
    intl: IntlShape
};

export const ResultsCount = (props: Props) => {
    let {
        resultsCount: {fromRecord, toRecord, resultCount},
        intl
    } = props;

    return (
        <div className="ResultsCount" data-wdio="ResultsCount">
            {resultsCountText(fromRecord, toRecord, resultCount, intl)}
        </div>
    );
};

export default compose(injectIntl)(ResultsCount);
